import { IBusiness } from '@query'
import { useMobileEmbed } from '@root/context'
import { allowsAppMarketOverride, redirectToCanonicalAppHost } from '@root/utils/marketHost'
import { useEffect } from 'react'

export const useMarketHostRedirect = (business?: IBusiness): void => {
  const { isEmbedded } = useMobileEmbed()

  useEffect(() => {
    if (allowsAppMarketOverride() || isEmbedded || !business?.country) {
      return
    }
    redirectToCanonicalAppHost(business.country)
  }, [business?.country, isEmbedded])
}
